"use strict";

exports.__esModule = true;
exports.CreateCommentUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _CreateCommentActionElement = require("./CreateCommentActionElement");
var _ = require(".");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CreateCommentUserAction = exports.CreateCommentUserAction = {
  name: "CreateComment",
  icon: "CommentsIcon",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateCommentUserActionDefinition.label",
    defaultMessage: "Create Comment"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateCommentUserActionDefinition.description",
    defaultMessage: "Create a comment"
  }),
  requiresContexts: ["device"],
  requiresProps: ["defaultCommentID"],
  components: {
    Element: _CreateCommentActionElement.CreateCommentActionElement,
    Fields: _.SelectDefaultCommentFields
  }
};